import { BookOpen, Link2, FileText } from 'lucide-react';
import { FC, useState } from 'react';
import AddLinks from './AddLinks';
import TrainingData from './TrainingData';
import TrainBot from './TrainBot';
import { SubTabBar, type SubTabItem } from './shared';

interface KnowledgeHubProps {
  token: string;
}

type SubTab = 'qa' | 'links' | 'files';

const SUB_TABS: readonly SubTabItem<SubTab>[] = [
  { value: 'qa', label: 'Q&A Pairs', icon: BookOpen },
  { value: 'links', label: 'Website Links', icon: Link2 },
  { value: 'files', label: 'Documents', icon: FileText },
];

const KnowledgeHub: FC<KnowledgeHubProps> = ({ token }) => {
  const [activeSubTab, setActiveSubTab] = useState<SubTab>('qa');

  return (
    <div className="flex flex-col">
      <SubTabBar tabs={SUB_TABS} value={activeSubTab} onChange={setActiveSubTab} />

      <div className="p-6">
        {activeSubTab === 'qa' && <TrainingData token={token} />}
        {activeSubTab === 'links' && <AddLinks token={token} />}
        {activeSubTab === 'files' && <TrainBot token={token} />}
      </div>
    </div>
  );
};

export default KnowledgeHub;
